import { createStyles } from '@material-ui/core/styles';

export const ReturnCreditsStyles = createStyles({
    ReturnCreditsContainer: {
        'maxWidth': 850,
        'height': 342,
        'display': 'flex',
        'flexDirection': 'column',
        'padding': '10px',
        '& > div': {
            border: '1px solid #ddd',
            maxWidth: '100% !important'
        },
        '@media screen and (max-width: 770px)': {
            height: 582,
        },
        '@media screen and (max-width: 428px)': {
            height: 624,
        }
    }
});
